<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div id="wy-footer">
    <table><!-- //NOSONAR -->
      <tr>
        <td>{{ $t('app.footer.copyright') }}</td>
        <td><span @click="handleAbout">{{ $t('app.footer.about') }}</span></td>
        <td><span @click="handlePrivacy">{{ $t('app.footer.privacy') }}</span></td>
      </tr>
    </table>
  </div>  
</template>

<script>
export default {
  name: 'wy-footer',

  methods: {
    handleAbout() {
      // TODO: show about popup
    },
    handlePrivacy() {
      // TODO: show privary popup
    }
  }
}
</script>

<style lang="scss">
#wy-footer {
  width: 100%;
  height: 100%;
  background-color:#fff;
  padding-top: 5px;
  font-size: 10px;
  color: #45464A;

  > table {
    td{
      padding-right: 20px;
      > span {
        cursor: pointer;
      }
    }
  }
}
</style>
